import { Injectable } from '@angular/core';
import { AnalyticsEventName } from './analytics.model';

type GtagFn = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: GtagFn;
  }
}

const ANALYTICS_DEBUG = typeof ngDevMode !== 'undefined' && ngDevMode;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private initialized = false;

  public init(): void {
    this.initialized = true;
  }

  public trackPageView(path: string): void {
    this.init();
    this.debugLog('page_view', {
      page_path: path,
      page_location: typeof location !== 'undefined' ? location.href : path,
    });
  }

  public trackEvent(name: AnalyticsEventName, params?: Record<string, string | number | boolean>): void {
    this.init();
    this.debugLog(name, params);
  }

  private debugLog(event: string, params?: Record<string, unknown>): void {
    if (!ANALYTICS_DEBUG) {
      return;
    }

    console.info('[analytics]', event, params ?? {});
  }
}
